import React from 'react';

const ContactDisambiguationModal = ({
  open,
  matches,
  title,
  subtitle,
  onSelect,
  onClose,
}) => {
  if (!open) return null;

  const safeMatches = Array.isArray(matches) ? matches : [];

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <div>
            <div style={styles.title}>{title || 'Which contact did you mean?'}</div>
            <div style={styles.subtitle}>
              {subtitle || 'Tap an option, or say “number 2”.'}
            </div>
          </div>
          <button style={styles.closeBtn} onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        {safeMatches.length === 0 ? (
          <div style={styles.empty}>No matches.</div>
        ) : (
          <div style={styles.list}>
            {safeMatches.map((m, idx) => {
              const n = idx + 1;
              const name = m?.contact_name || 'Unknown';
              const company = m?.company_name;
              const phone = m?.phone;
              const email = m?.email;
              const lastActivityAt = m?.last_activity_at;
              const lastActivityType = m?.last_activity_type;

              const metaBits = [
                company ? `🏢 ${company}` : null,
                phone ? `📞 ${phone}` : null,
                email ? `📧 ${email}` : null,
              ].filter(Boolean);

              const lastBits = [
                lastActivityType ? `Last: ${lastActivityType}` : null,
                lastActivityAt ? new Date(lastActivityAt).toLocaleString('en-AU') : null,
              ].filter(Boolean);

              return (
                <button
                  key={m?.contact_id || idx}
                  style={styles.option}
                  onClick={() => onSelect?.(m, idx)}
                >
                  <div style={styles.optionTopRow}>
                    <div style={styles.badge}>{n}</div>
                    <div style={styles.name}>{name}</div>
                  </div>

                  {metaBits.length > 0 && (
                    <div style={styles.meta}>{metaBits.join(' • ')}</div>
                  )}

                  {lastBits.length > 0 && (
                    <div style={styles.lastActivity}>{lastBits.join(' • ')}</div>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    zIndex: 1000,
  },
  modal: {
    width: '100%',
    maxWidth: '520px',
    background: '#0b1220',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '14px',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px',
    marginBottom: '12px',
  },
  title: {
    color: '#e2e8f0',
    fontWeight: 800,
    fontSize: '16px',
  },
  subtitle: {
    color: '#94a3b8',
    fontSize: '13px',
    marginTop: '4px',
  },
  closeBtn: {
    background: 'transparent',
    border: 'none',
    color: '#94a3b8',
    cursor: 'pointer',
    fontSize: '18px',
    lineHeight: '18px',
    padding: '6px',
  },
  empty: {
    color: '#94a3b8',
    padding: '12px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  option: {
    textAlign: 'left',
    width: '100%',
    background: '#111827',
    border: '1px solid #334155',
    borderRadius: '10px',
    padding: '12px',
    cursor: 'pointer',
    minHeight: '56px',
  },
  optionTopRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  badge: {
    width: '26px',
    height: '26px',
    borderRadius: '8px',
    background: 'var(--brand-primary, #3b82f6)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 800,
    flexShrink: 0,
  },
  name: {
    color: '#f1f5f9',
    fontWeight: 700,
  },
  meta: {
    marginTop: '6px',
    color: '#cbd5e1',
    fontSize: '13px',
  },
  lastActivity: {
    marginTop: '6px',
    color: '#94a3b8',
    fontSize: '12px',
  },
};

export default ContactDisambiguationModal;
